var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"d-flex p-normal"},[_c('img',{attrs:{"src":_vm.image,"alt":"test"}}),_vm._v(" "),_c('h5',[_vm._v(" "+_vm._s(_vm.message)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }